import React from 'react';
import _, { isEmpty, cloneDeep, filter } from 'lodash';
import Select from 'react-select';

import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import Modal from '@material-ui/core/Modal';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

import { getProviderObjFromAPI, fetchProviderList } from '../../common/providers';
import { getStopType } from '../../common/routes';
import { getHumanReadableText } from '../../common/global';
import ACButton from '../../atoms/ACButton';

import styles from './SetStop.module.scss';

export default class SetStop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProvider: {},
      selectedProviderOption: {},
      selectedstoryboard: {},
      selectedItem: {},
      isStoryboardEnabled: false,
      providerList: [],
      types: Object.values(getStopType()).map((v) => {
        return {
          label: getHumanReadableText(v),
          value: v,
        };
      }),

    };

    this.onSaveStop = this.onSaveStop.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onChangeActionText = this.onChangeActionText.bind(this);

    this.onDeleteStop = this.onDeleteStop.bind(this);
    this.onDeleteStopProvider = this.onDeleteStopProvider.bind(this);

    this.onChangeProvider = this.onChangeProvider.bind(this);
    this.onChangeItem = this.onChangeItem.bind(this);

    this.onInputChangeProviderName = this.onInputChangeProviderName.bind(this);
    this.onChangeStopVariables = this.onChangeStopVariables.bind(this);
    this.onChangeStopType = this.onChangeStopType.bind(this);
    this.onChangeStoryBoard = this.onChangeStoryBoard.bind(this);
  }


  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  onKeyDown(event) {
    if (event.keyCode === 27) {
      //Escape key
      this.props.onCloseFunc();
    }
  }

  getProviderList = (value) => {
    const filterStr = '&query=' + encodeURIComponent(value);

    fetchProviderList(filterStr)
      .then(providerList => {
        if (providerList) {
          this.setState({ providerList });
        } else {
          this.setState({ providerList: [] });
        }
      })
      .catch(error => {
        console.log('ERROR : getProviderList : ', error);
        this.props.showErrorToast('Failed getting proviers list.', error);
        this.setState({ providerList: [] });
      });
  }


  onInputChangeProviderName(value) {
    if (value) {
      this.handleSearchDebounced(value);
    } else {
      // keep the previous provider list
      this.setState({ providerList: [...this.state.providerList] })
    }
  }

  handleSearchDebounced = _.debounce((value) => {
    this.getProviderList(value);
  }, 500);

  onSaveStop() {
    console.log('onSaveStop')
    this.props.onSaveStopFunc();
    if (this.closeSetStop()) this.props.onCloseFunc();
  }

  closeSetStop() {
    let closeIt = false;
    const { stop = {} } = this.props;
    const { type = '' } = stop;

    if (
      !isEmpty(stop) &&
      (!isEmpty(stop.clue) || type === 'payment-only') &&
      !isEmpty(stop.provider) &&
      stop.type
    ) {
      if (type === getStopType().INSTA_STOP || !isEmpty(stop.item)) {
        closeIt = true;
      }
      if (stop.provider.enablingStoryboard && isEmpty(this.state.selectedstoryboard)) {
        closeIt = false;
      }      
    }
    return closeIt;
  }

  onDeleteStop(deleteStopIndex) {
    this.props.onDeleteStopFunc(deleteStopIndex);
    this.props.onCloseFunc();
  }

  onDeleteStopProvider(providerId) {
    this.props.onDeleteStopProviderFunc(providerId);
  }

  onChangeClue(clue) {
    this.props.onSelectClueFunc(clue);
  }

  onChangeProvider(provider) {

    if (provider && provider.value) {
      let selectedProviderOption = cloneDeep(this.state.selectedProviderOption);
      selectedProviderOption.label = provider.label;
      selectedProviderOption.value = provider.value;

      this.setState({
        selectedProvider: { ...(provider.object || {}) },
        selectedProviderOption: selectedProviderOption,
      });
      this.props.onSelectProviderFunc(provider.object,this.props.stop.providerId);

    }
  }

  onChangeStoryBoard(storyboard) {
    let selectedstoryboard = cloneDeep(this.state.selectedstoryboard);
    selectedstoryboard.label = storyboard.label;
    selectedstoryboard.value = storyboard.value;
    this.setState({
      selectedstoryboard,
    });
    this.props.onUpdateStoryBoardFunc(selectedstoryboard);
  }

  onChangeItem(item) {
    let selectedItem = cloneDeep(this.state.selectedItem);
    selectedItem.label = item.label;
    selectedItem.value = item.value;

    this.setState({
      selectedItem,
    });
    this.props.onSelectItemFunc(item.object);
  }

  onChangeActionText(event) {
    this.props.onUpdateStopActionFunc(event.target.value);
  }

  onChangeStopVariables(key, event) {
    let { variables = {} } = this.props.stop;
    variables[key] = event.target.checked;
    this.props.onUpdateStopVariablesFunc(variables);
  }

  onChangeStopType(type) {
    const { value = '' } = type;

    if (value) {
      this.props.onUpdateStopTypeFunc(value);
    }
  }

  getSuitableForPersons(suitables) {
    let suitableComponents = [];
    // console.log('suitables', suitables);
    if (suitables) {
      suitables.forEach((s) => {
        let adults = s.adults || 0;
        let children = s.children || 0;

        if (!(adults <= 0 && children <= 0)) {
          suitableComponents.push(
            <div
              style={{
                margin: '3px',
              }}
            >
              <Chip
                label={adults}
                style={{
                  visibility: adults ? 'visible' : 'collapse',
                  backgroundColor: 'black',
                  borderColor: 'black',
                  color: 'white',
                  fontSize: '12px',
                }}
                className={styles.circle}
              />
              <Chip
                label={children}
                style={{
                  visibility: children ? 'visible' : 'collapse',
                  backgroundColor: 'white',
                  borderColor: 'black',
                  color: 'black',
                  fontSize: '12px',
                }}
                className={styles.circle}
              />
            </div>
          );
        }
      });
    }
    return suitableComponents;
  }

  renderTopPanel(showDeleteIcon, deleteStopIndex, providerId) {
    let deleteIcon = <div />;
    if (showDeleteIcon === true) {
      deleteIcon = (
        <div className={styles.topBarIcon}>
          <DeleteIcon
            style={{
              color: '#FF765F',
            }}
            //While called from Planner level, use onDeleteStopProvider to delete the provider stop; else from route level use onDeleteStop
            onClick={() => this.props.onDeleteStopProviderFunc ? this.onDeleteStopProvider(providerId) : this.onDeleteStop(deleteStopIndex)}
          />
        </div>
      );
    }

    return (
      <div className={styles.top}>
        <div>
          <h3>Set Stop</h3>
        </div>
        {deleteIcon}
        <div
          className={styles.topBarIcon}
          style={{
            marginRight: '0',
          }}
        >
          <CloseIcon onClick={this.props.onCloseFunc} />
        </div>
      </div>
    );
  }

  renderProvider(stop, providers) {
    let { selectedProviderOption = {} } = cloneDeep(this.state);
    if (isEmpty(stop)) {
      selectedProviderOption = {
        label: '',
        value: '',
      };
    } else {
      if (stop && stop.provider) {
        selectedProviderOption = {
          label: stop.provider.name,
          value: stop.provider.id,
        };
      }
    }

    let mProviders = [];
    if (!providers) return <div />;
    providers.forEach((provider) => {
      let p = getProviderObjFromAPI(provider);

      let objProvider = provider;

      let mProvider = {
        label: p.providerName,
        value: p.id,
        object: objProvider,
        enablingStoryboard: p.enablingStoryboard ? p.enablingStoryboard : false
      };
      mProviders.push(mProvider);
    });

    return (
      <div className={styles.providers}>
        <div>
          <span
            style={{
              fontSize: '20px',
            }}
          >
            Provider Name
          </span>
          <Select
            className={styles.providerSelect}
            inputId="react-select-single"
            TextFieldProps={{
              label: 'Provider Name 2',
              InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
              },
              placeholder: 'Select Provider',
            }}
            options={mProviders}
            value={selectedProviderOption}
            onChange={this.onChangeProvider}
            onInputChange={this.onInputChangeProviderName}
          />
        </div>
      </div>
    );
  }

  renderProviderStoryBoards(stop, providerStoryboards) {
    let { selectedstoryboard = {} } = cloneDeep(this.state);
  
    if (isEmpty(stop)) {
      selectedstoryboard = {
        label: '',
        value: '',
      }
    } else {

      if (stop && stop.storyboard) {
        selectedstoryboard = {
          label: stop.storyboard.label,
          value: stop.storyboard.value,
        }
      }
    }
    let storyboards = []
    if (providerStoryboards) {
      storyboards = [...providerStoryboards];
    }
    let mstoryboards = [];
    if (!storyboards) return <div />;
    storyboards.forEach((storyboard) => {

      let mstoryboard = {
        label: storyboard.name,
        value: storyboard.id
      };
      mstoryboards.push(mstoryboard);
    });

    return (
      <div className={styles.providers}>
        <div>
          <span
            style={{
              fontSize: '20px',
            }}
          >
            Storyboard
          </span>
          <Select
            className={styles.providerSelect}
            inputId="react-select-single"
            TextFieldProps={{
              label: 'Provider Name 2',
              InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
              }

            }}
            placeholder='Select Storyboard'
            options={mstoryboards}
            value={selectedstoryboard}
            onChange={this.onChangeStoryBoard}
          />
        </div>
      </div>
    );
  }

  renderItems(stop, items) {
    let mItems = [];
    let selectedItemSuitables = [];
    let { selectedItem = {}, selectedStopType = {} } = cloneDeep(this.state);

    if (isEmpty(stop)) {
      selectedItem = {
        label: '',
        value: '',
      };
    } else {
      if (stop && stop.item) {
        selectedItem = {
          label: stop.item.name,
          value: stop.item.id,
        };
        const { suitables = [] } = stop.item;

        if (suitables.length > 0) {
          selectedItemSuitables = this.getSuitableForPersons(suitables);
        }
      }
    }
    if (items.length < 0) return <div />;

    items.forEach((i) => {
      let objItem = i;
      if (i.status !== 'active') return;
      let jsonString = '';
      if (objItem.suitables && !isEmpty(objItem.suitables) && objItem.suitables.length > 0) {
        if (!(objItem.suitables.length === 1 && isEmpty(objItem.suitables[0]))) {
          jsonString = JSON.stringify(objItem.suitables);
          jsonString = jsonString.replace(/adults/g, 'A');
          jsonString = jsonString.replace(/children/g, 'C');
        }
      }
      let item = {
        label: i.name + ' ' + jsonString, // i.name,
        value: i.id,
        object: objItem,
      };
      if (selectedStopType.value === 'tasting-stop') {
        if (!isEmpty(objItem.subItems) && objItem.subItems.length > 0) mItems.push(item);
      } else mItems.push(item);
    });



    return (
      <div>
        <div className={styles.products}>
          <span
            style={{
              fontSize: '20px',
            }}
          >
            Product/Service
          </span>
          <Select
            className={styles.providerSelect}
            inputId="react-select-single"
            TextFieldProps={{
              label: 'Product Name 2',
              InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
              },
              placeholder: 'Select Product / Service',
            }}
            options={mItems}
            value={selectedItem}
            onChange={this.onChangeItem}
          />
        </div>
        {!isEmpty(selectedItemSuitables) ? (
          <div style={{ margin: '10px 0px 20px 0px' }}>
            Suitable for:<div style={{ margin: '5px' }}>{selectedItemSuitables}</div>
          </div>
        ) : null}
      </div>
    );
  }

  renderClues(stop, clues) {
    return (
      <div className={styles.cluesRender}>
        <div className={styles.title}>Available Clues</div>
        <div className={styles.bottom}>
          <List className={styles.clueList}>{this.renderClueCards(stop, clues)}</List>
        </div>
      </div>
    );
  }

  renderStopVariables(variables) {
    const { isPicnic = false, isDropOff = false } = variables;
    return (
      <div>
        <FormControlLabel
          control={<Checkbox color="primary" checked={isPicnic} />}
          label="Is a picnic location?"
          key="chkBoxIsPicnicLocation"
          onChange={(e) => this.onChangeStopVariables('isPicnic', e)}
        />

        <FormControlLabel
          control={<Checkbox color="primary" checked={isDropOff} />}
          label="Is this a drop off?"
          key="chkIsDropOff"
          onChange={(e) => this.onChangeStopVariables('isDropOff', e)}
        />
      </div>
    );
  }

  renderType(typeValue) {
    // console.log(typeValue,"typeValue")
    // AMZG-2330 && AMZG_2310
    // Filter out SPARK_STOP, BASKET_RETURN and FINAL_STOP
    // Thes stop types have special meaning elsewhere but should not be selectable.
    // COMPONENT_STOP is here for the same reason: it is written by the backend, and a stop
    // hand-set to it renders as a placeholder with a fabricated clue and provider. Reachable
    // since a ticketed component gained Add Stop.
    const types = filter(cloneDeep(this.state.types), (t) => {
      return t.value !== getStopType().SPARK_STOP &&
        t.value !== getStopType().BASKET_RETURN &&
        t.value !== getStopType().FINAL_STOP &&
        t.value !== getStopType().COMPONENT_STOP
    });
    if (isEmpty(types)) {
      return null;
    }

    let type = types.find((t) => t.value === typeValue);
    if(!type){
      type=''
    }

    return (
      <div className={styles.types}>
        <div>
          <span
            style={{
              fontSize: '20px',
            }}
          >
            Type
          </span>
          <Select
            className={styles.typeSelect}
            inputId="react-select-single"
            options={types}
            value={type}
            onChange={this.onChangeStopType}
          />
        </div>
      </div>
    );
  }

  renderNotes(action) {
    const { selectedstoryboard } = cloneDeep(this.state);

    const storyboards = this.props.storyboards;
    let stop = this.props.stop;

    let storyboard;
    let value = ''
    const check = !isEmpty(selectedstoryboard) || !isEmpty(stop.storyboard);
    if (!isEmpty(selectedstoryboard)) {
      storyboard = storyboards.find((val) => val.id === selectedstoryboard.value)
      value = storyboard?.internalNote
    } else if (stop.storyboard) {
      storyboard = storyboards.find((val) => val.id === stop.storyboard.value)
      value = storyboard?.internalNote
    }
    return (
      <div className={styles.action}>
        <span>Internal Notes</span>
        <TextField
          disabled={check ? true : false}
          value={check ? value : action}
          className={styles.action}
          onChange={(e) => this.onChangeActionText(e)}
        />
      </div>
    );
  }

  renderClueCards(stop, clues) {
    let selectedClue = {};
    if (!isEmpty(stop)) {
      if (stop.clue) {
        selectedClue = {
          name: stop.clue.name,
          id: stop.clue.id,
        };
      }
    }


    if (isEmpty(clues) || clues.length <= 0) return <div />;
    return clues.map((clue) => {
      return this.renderClue(selectedClue, clue);
    });
  }

  renderClue(selectedClue, clue) {
    const c = selectedClue;
    if (isEmpty(clue)) return;

    let s = [styles.clueLististItem];
    if (clue && clue.id === c.id) {
      s.push(styles.selected);
    }

    return (
      <ListItem className={s.join(' ')} onClick={() => this.onChangeClue(clue)}>
        <span className={styles.clueName}>{clue.name}</span>
      </ListItem>
    );
  }

  renderDetails(isStoryBoardEnabled, stop, clues, storyboards, type, action, items) {
    if (isStoryBoardEnabled) {
      return (<>
        {this.renderType(type)}
        {this.renderClues(stop, clues)}
        {this.renderProviderStoryBoards(stop, storyboards)}
        {this.renderNotes(action)}
        {this.renderItems(stop, items)}
      </>)
    }
    else {
      return (<>
        {this.renderItems(stop, items)}
        {this.renderClues(stop, clues)}
        {this.renderNotes(action)}
        {this.renderType(type)}
      </>)
    }
  }

  render() {
    const stop = this.props.stop || {};


    const showDeleteIcon = stop.index >= 0 ? true : false;
    //const action = stop.action ? stop.action : '';
    const {
      action = '',
      // variables = {},
      type = '',
      storyboard = {},
      provider,
    } = stop;


    // const selectedProviderOption = this.state.selectedProviderOption;
    // let selectedProviderData = this.state.selectedProvider;
    // let storyBoardEnabled = false;
    // if(selectedProviderOption){
    //   storyBoardEnabled = !isEmpty(storyboard) ? true: (selectedProviderData?.enablingStoryboard? selectedProviderData?.enablingStoryboard : false)
    // }

    let isStoryBoardEnabled = false;
    if(provider?.enablingStoryboard) {
      isStoryBoardEnabled = provider?.enablingStoryboard;
    }

    if (this.state.selectedProviderOption) {
      const selectedProviderData = this.state.selectedProvider;
      if (!isEmpty(storyboard)) {
        isStoryBoardEnabled = true;
      } else if (selectedProviderData?.enablingStoryboard) {
        isStoryBoardEnabled = selectedProviderData.enablingStoryboard;
      }
    }

    return (
      <Modal open={this.props.isModifying} onClose={this.props.onCloseFunc} className={styles.root}>
        <div className={styles.list}>
          {this.renderTopPanel(showDeleteIcon, stop.index, stop.providerId)}
          {this.renderProvider(stop, this.state.providerList)}
          {this.renderDetails(isStoryBoardEnabled, stop, this.props.clues, this.props.storyboards, type, action, this.props.items)}

          {/* TODO: Delete this and use the new type instead */}
          {/* {this.renderStopVariables(variables)} */}
          <div className={styles.saveButton}>
            <ACButton
              zIndex='0'
              position='relative'
              bottom='10px'
              text={'Save'}
              icon={<SaveIcon />}
              iconLast={true}
              onClickFunc={this.onSaveStop}
            />
          </div>
        </div>
      </Modal>
    );
  }
}
